import { StyleSheet } from 'react-native';
import { pt, px } from '../common/utils';

export default StyleSheet.create({
    container: {
        backgroundColor: '#F5F5F5',
        flex: 1
    },
    nav_btn: {
        width: pt(36),
        height: pt(36),
        marginHorizontal: pt(8),
        resizeMode: 'contain',
        marginLeft: pt(5)
    },
    banner: {
        height: pt(135),
        width: pt(375),
        overflow: 'hidden',
        justifyContent: 'center'
    },
    banner_top: {
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: pt(18)
    },
    avatar: {
        width: pt(44),
        height: pt(44),
        borderRadius: pt(22)

    },
    banner_login: {
        color: '#ffffff',
        fontSize: pt(14),
        fontWeight: 'bold',
        backgroundColor: 'transparent'
    },
    username: {
        color: '#ffffff',
        fontSize: pt(14),
        marginLeft: pt(9),
        fontWeight: 'bold',
        backgroundColor: 'transparent'
    },
    banner_circle1: {
        width: pt(18),
        height: pt(18),
        borderRadius: pt(9),
        backgroundColor: '#FAD961',
        position: 'absolute',
        top: pt(3),
        left: pt(191),
        opacity: 0.2
    },
    banner_circle2: {
        width: pt(64),
        height: pt(64),
        borderRadius: pt(32),
        backgroundColor: '#FAD961',
        position: 'absolute',
        top: pt(38),
        left: pt(200),
        opacity: 0.2
    },
    banner_circle3: {
        width: pt(150),
        height: pt(150),
        borderRadius: pt(75),
        backgroundColor: '#FAD961',
        position: 'absolute',
        top: pt(-30),
        left: pt(245),
        opacity: 0.3
    },
    banner_bottom: {
        width: pt(375),
        height: pt(52),
        flexDirection: 'row',
        backgroundColor: '#fff',
        marginBottom: pt(6),
        // borderBottomColor: '#E6EEF5',
        alignItems: 'center'
    },
    banner_bottomJR: {
        width: pt(375),
        height: pt(52),
        // flexDirection: 'row',
        backgroundColor: '#fff',
        marginBottom: pt(6),
        borderBottomColor: '#E6EEF5',
        alignItems: 'center'
    },
    banner_sum: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: pt(52)
    },
    banner_mid: {
        width: px(1),
        height: pt(30),
        backgroundColor: '#D8D8D8',
        marginLeft: pt(43),
        marginTop: pt(7),
        marginBottom: pt(13)
    },
    banner_img: {
        width: pt(22),
        height: pt(22),
        marginLeft: pt(50),
        marginRight: pt(6)
        // marginTop: pt(),
        // marginBottom: pt(16)
    },
    banner_img_jr: {
        width: pt(22),
        height: pt(22),
        // marginLeft: pt(50),
        marginRight: pt(6)
        // marginTop: pt(),
        // marginBottom: pt(16)
    },
    banner_text: {
        fontSize: pt(13),
        color: '#252525'
    },
    banner_img1: {
        width: pt(22),
        height: pt(23),
        marginLeft: pt(43),
        marginRight: pt(5),
        marginTop: pt(15),
        marginBottom: pt(15)
    },
    red: {
        marginLeft: '2.66%',
        marginBottom: pt(13),
        width: '94.68%',
        borderRadius: pt(4),
        backgroundColor: '#fff'
    },
    tip: {
        borderTopLeftRadius: pt(3),
        borderTopRightRadius: pt(3)
    },
    tip_top: {
        width: pt(355),
        height: pt(7),
        borderTopLeftRadius: pt(3),
        borderTopRightRadius: pt(3),
        backgroundColor: '#FF2000'
    },
    tip_bottom: {
        width: '100%',
        marginTop: pt(30),
        paddingBottom: pt(23)
    },
    tip_bottom_con: {
        flexDirection: 'row',
        justifyContent: 'center',
        height: pt(27),
        alignItems: 'center'
    },

    // 中间内容部分
    content: {
        backgroundColor: '#fff',
        marginBottom: pt(6),
        paddingVertical: pt(7)
    },
    contetn_item: {
        paddingHorizontal: pt(15),
        paddingVertical: pt(10)
    },
    content_specia: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    content_left: {
        flexDirection: 'row',
        alignItems: 'center',
        height: pt(16)
    },
    content_left_mark_wrap: {
        width: pt(14),
        height: pt(15),
        backgroundColor: '#F56A00',
        borderRadius: pt(2),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: pt(6)
    },
    content_ding: {
        backgroundColor: '#5F35A9'
    },
    content_quan: {
        backgroundColor: '#27BD72'
    },
    content_ying: {
        backgroundColor: '#FFA13D'
    },
    content_dui: {
        backgroundColor: '#2B84FF'
    },
    content_left_mark: {
        fontSize: pt(10),
        color: '#fff'
    },
    content_left_text: {
        fontSize: pt(14),
        color: '#252525'
    },
    content_right: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    content_right_text: {
        fontSize: pt(13),
        color: '#252525',
        fontWeight: 'bold'
    },
    content_right_img: {
        marginLeft: pt(5),
        width: pt(4),
        height: pt(11)
    },

    // 底部
    foot: {
        backgroundColor: '#fff',
        paddingVertical: pt(7)
    },
    foot_item: {
        paddingHorizontal: pt(15),
        paddingVertical: pt(10)
    },
    foot_special: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: pt(16)
    },
    foot_left: {
        fontSize: pt(14),
        color: '#252525'
    },
    foot_right: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    foot_right_text: {
        fontSize: pt(13),
        color: '#252525',
        fontWeight: 'bold'
    },
    foot_right_img: {
        marginLeft: pt(5),
        width: pt(4),
        height: pt(11)
    },

    feedback: {
        backgroundColor: '#fff',
        // height: pt(45),
        justifyContent: 'center',
        marginVertical: pt(7)
    },
    feedback_txt: {
        fontSize: pt(12),
        color: '#bbb'
    }
});
